"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCTAs = void 0;
var canSubmitReads_1 = require("./canSubmitReads");
var reads_config_1 = require("./reads-config");
var getCTAs = function (supplyStates) {
    var hasIndustryOpeningRead = supplyStates.hasIndustryOpeningRead;
    var actions = [];
    if ((0, canSubmitReads_1.canSubmitReads)(supplyStates)) {
        actions.push('SubmitReading');
    }
    if (!(0, reads_config_1.readsConfig)('industryReadsRequired') || hasIndustryOpeningRead) {
        actions.push('ViewHistory');
    }
    return actions;
};
exports.getCTAs = getCTAs;
